import axiosInstance from '../axiosInterceptor/axiosInstance'

// Today's and future games of the season teams paired to the given club team — the list
// the game create/edit form picks from when connecting a club game to a federation game.
// Org-scoped: the club team must belong to orgId (the org in the route).
const getGamePairingCandidates = async (orgId, clubTeamId) =>
  (await axiosInstance.get(`v1/orgs/${orgId}/pairings/games/candidates`, { params: { clubTeamId } }))
    ?.data

export default getGamePairingCandidates
